import authentication from '../middleware/authentication'
const FormSettingTextReply = () => import(/* webpackChunkName: "static/js/chunks/companySetting" */'../../views/lineChat/FormSettingTextReply')

const formSettingTextReplyResponseRoutes = {
  path: '/line-setting-text-reply',
  name: 'FormSettingTextReply',
  component: FormSettingTextReply,
  meta: {
    middleware: authentication,
    layout: 'main',
    pageTitle: '自動応答メッセージ'
  }
}

export default formSettingTextReplyResponseRoutes
